import KindType from '../enums/KindType'

export default {
  [KindType.facebookPost]: 4 / 5,
  [KindType.instagramPost]: 4 / 5,
  [KindType.facebookAds]: 3 / 4,
  [KindType.gmbProductDescription]: 1,
  [KindType.linkedinPost]: 1,
  [KindType.gmbNewsPost]: 1,
  [KindType.whatsappStatus]: 9 / 16,
}
